import React, { useContext } from 'react'

// Types
import { UseWpoktMintControllerReturnType } from 'hooks/useWpoktMintController/useWpoktMintController.types'

// Constants
import { useWpoktMintControllerDefaultReturnType } from 'hooks/useWpoktMintController/useWpoktMintController.constants'

// Hooks
import { useWpoktMintController } from 'hooks/useWpoktMintController/useWpoktMintController'

const WpoktMintControllerContext = React.createContext<UseWpoktMintControllerReturnType>(
    useWpoktMintControllerDefaultReturnType
)

interface WpoktMintControllerProviderProps {
    children: React.ReactNode
}

export const WpoktMintControllerProvider = ({
    children,
}: WpoktMintControllerProviderProps) => {
    const WpoktMintControllerState = useWpoktMintController()

    return (
        <WpoktMintControllerContext.Provider value={WpoktMintControllerState}>
            {children}
        </WpoktMintControllerContext.Provider>
    )
}

export const useWpoktMintControllerContext = () => useContext(WpoktMintControllerContext)